export default {
  'Resolution': 'Resolução',
  'Frame rate': 'Taxa de quadros',
  'The higher the frame rate, the smoother the animation': 'Quanto maior a taxa de quadros, mais suave será a animação.',
}